"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import {
  Button,
  Anchor as MantineAnchor,
  Box as MantineBox,
  Text as MantineText,
} from "@mantine/core";
import { socialLinks } from "@/lib/shared/constants";
import SocialIcon from "@/components/layout/SocialIcon";

import styles from "./styles.module.scss";

interface SocialMenuProps {
  isOpen: boolean;
  onToggle: () => void;
}

const SocialMenu = ({ isOpen, onToggle }: SocialMenuProps) => {
  const pathname = usePathname();

  useEffect(() => {
    if (isOpen) {
      onToggle();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <MantineBox
      className={styles.socialMenuContainer}
      onMouseEnter={() => {
        if (!isOpen) onToggle();
      }}
      onMouseLeave={() => {
        if (isOpen) onToggle();
      }}
    >
      <Button onClick={onToggle} variant="unstyled" aria-expanded={isOpen}>
        SOCIALS
      </Button>
      <MantineBox className={styles.socialsMenu} data-open={isOpen}>
        {socialLinks.map(({ name, url }) => (
          <MantineAnchor
            key={name}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={name}
          >
            <SocialIcon name={name} />
            <MantineText span className={styles.srOnly}>
              {name}
            </MantineText>
          </MantineAnchor>
        ))}
      </MantineBox>
    </MantineBox>
  );
};

export default SocialMenu;
